import React from 'react';
import { motion } from 'framer-motion';
import { useI18n } from '../i18n';

const TermsOfService = () => {
  const { t } = useI18n();

  const Section = ({ titleKey, children }) => (
    <section className="max-w-3xl mx-auto px-4 py-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-3">{t(titleKey)}</h2>
      {children}
    </section>
  );

  const Bullet = ({ children }) => (
    <li className="pl-2 ml-4 list-disc text-gray-700">{children}</li>
  );

  return (
    <div className="pt-20 bg-gray-50 min-h-screen">
      <motion.section
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-gradient-to-r from-blue-800 to-blue-900 text-white py-14 text-center"
      >
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-3">{t('terms.hero.title')}</h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto">{t('terms.hero.subtitle')}</p>
          <p className="text-sm mt-2 opacity-80">{t('terms.effective')}</p>
        </div>
      </motion.section>

      <Section titleKey="terms.sections.acceptance.title">
        <p className="text-gray-700">{t('terms.sections.acceptance.text')}</p>
      </Section>

      <Section titleKey="terms.sections.use.title">
        <ul className="space-y-2">
          <Bullet>{t('terms.sections.use.items.lawful')}</Bullet>
          <Bullet>{t('terms.sections.use.items.account')}</Bullet>
          <Bullet>{t('terms.sections.use.items.responsibility')}</Bullet>
        </ul>
      </Section>

      <Section titleKey="terms.sections.prohibited.title">
        <ul className="space-y-2">
          <Bullet>{t('terms.sections.prohibited.items.illegal')}</Bullet>
          <Bullet>{t('terms.sections.prohibited.items.abuse')}</Bullet>
          <Bullet>{t('terms.sections.prohibited.items.security')}</Bullet>
          <Bullet>{t('terms.sections.prohibited.items.infringement')}</Bullet>
        </ul>
      </Section>

      <Section titleKey="terms.sections.ip.title">
        <p className="text-gray-700">{t('terms.sections.ip.text')}</p>
      </Section>

      <Section titleKey="terms.sections.links.title">
        <p className="text-gray-700">{t('terms.sections.links.text')}</p>
      </Section>

      <Section titleKey="terms.sections.disclaimer.title">
        <p className="text-gray-700">{t('terms.sections.disclaimer.text')}</p>
      </Section>

      <Section titleKey="terms.sections.liability.title">
        <p className="text-gray-700">{t('terms.sections.liability.text')}</p>
      </Section>

      <Section titleKey="terms.sections.indemnity.title">
        <p className="text-gray-700">{t('terms.sections.indemnity.text')}</p>
      </Section>

      <Section titleKey="terms.sections.governingLaw.title">
        <p className="text-gray-700">{t('terms.sections.governingLaw.text')}</p>
      </Section>

      <Section titleKey="terms.sections.termination.title">
        <p className="text-gray-700">{t('terms.sections.termination.text')}</p>
      </Section>

      <Section titleKey="terms.sections.changes.title">
        <p className="text-gray-700">{t('terms.sections.changes.text')}</p>
      </Section>

      <Section titleKey="terms.sections.contact.title">
        <p className="text-gray-700">{t('terms.sections.contact.text')}</p>
      </Section>

      <Section titleKey="terms.sections.sms.title">
        <p className="text-gray-700">{t('terms.sections.sms.p1')}</p>
        <p className="text-gray-700 mt-3">{t('terms.sections.sms.types')}</p>
        <p className="text-gray-700 mt-1 font-semibold">{t('terms.sections.sms.frequency')}</p>
        <p className="text-gray-700 mt-1">{t('terms.sections.sms.costs')}</p>
        <p className="text-gray-700 mt-1 font-semibold">{t('terms.sections.sms.optout')}</p>
        <p className="text-gray-700 mt-3">{t('terms.sections.sms.noCondition')}</p>
        <p className="text-gray-700 mt-3 text-sm">{t('terms.sections.sms.contact')}</p>
      </Section>

      <div className="h-8" />
    </div>
  );
};

export default TermsOfService;
